import { AdviserFormController } from './adviserForm.controller';
import template from './adviserForm.html';

export const adviserForm = {
  name: 'adviserForm',
  restrict: 'E',
  template,
  controller: AdviserFormController,
  controllerAs: 'vm',
  bindings: {
    isEditing: '=',
    form: '=',
    branchId: '=',
    adviser: '=',
    showBranchId: '<',
    showAdviser: '<',
    ticketId: '<',
  },
};
